import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../lib/utils"

const sectionVariants = cva(
  "py-16 px-4 md:py-20 md:px-8",
  {
    variants: {
      variant: {
        dark: "bg-slate-950/80 backdrop-blur-sm text-white",
        light: "bg-white/90 backdrop-blur-sm text-slate-900 dark:bg-slate-900/50 dark:text-white",
        transparent: "bg-transparent text-inherit",
      },
    },
    defaultVariants: {
      variant: "transparent",
    },
  }
)

function Section({
  className,
  variant = "light",
  ...props
}: React.ComponentProps<"section"> & VariantProps<typeof sectionVariants>) {
  return (
    <section
      data-slot="section"
      data-variant={variant}
      className={cn(sectionVariants({ variant }), className)}
      {...props}
    />
  )
}

function SectionContainer({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="section-container"
      className={cn("max-w-6xl mx-auto", className)}
      {...props}
    />
  )
}

export { Section, sectionVariants, SectionContainer }
